import { IComparer } from './IComparer';

export abstract class BaseComparerBuilder<T, U> {
    abstract buildComparer(selector: (model: T) => U, ascending: boolean): IComparer<T>;

    protected getOrderMultiplier(ascending: boolean): number {
        return ascending ? 1 : -1;
    }
}
